import { keys as parentKeys } from '@copro/api';

const all = [...parentKeys.all, 'topics'] as const;

export const keys = {
  all,

  // Lists
  lists: () => [...all, 'lists'] as const,

  topicListArchivedOrNot: (showArchived: boolean) => [...keys.lists(), { showArchived }] as const,
  topicListPagedAll: () => [...keys.lists(), 'paged'] as const,
  topicListPaged: (status: string, search: string, page: number, perPage: number) => [...keys.topicListPagedAll(), { status, search, page, perPage }] as const,
  topic: (id: string) => [...keys.lists(), 'topic', id] as const,

  subTopicList: () => [...keys.lists(), 'subTopicList'] as const,
  subTopicListByTopicId: (topicId: string) => [...keys.subTopicList(), { topicId }] as const,
  subTopicListByTopicIdArchivedOrNot: (topicId: string, showArchived: boolean) => [...keys.subTopicListByTopicId(topicId), { showArchived }] as const,
  subTopicListPaged: (topicId: string, status: string, search: string, page: number, perPage: number) => [...keys.subTopicListByTopicId(topicId), 'paged', { status, search, page, perPage }] as const,
  subTopicCounts: (topicId: string) => [...keys.subTopicListByTopicId(topicId), 'counts'] as const,
  subTopicActiveCounts: (topicIds: string[]) => [...keys.subTopicList(), 'activeCounts', [...topicIds].sort()] as const,

  pendingSubTopics: (spaceId: string) => [...keys.subTopicList(), 'pendingSubTopics', spaceId] as const,

  openTasks: (spaceId: string) => [...keys.subTopicList(), 'openTasks', spaceId] as const,
  openPendingItems: (spaceId: string) => [...keys.subTopicList(), 'openPendingItems', spaceId] as const,

  // Single SubTopic Detail and its sub-resources
  subTopic: (id: string) => [...keys.subTopicList(), 'subTopic', id] as const,

  getHistoryFeedBySubTopicId: (subTopicId: string) => [...keys.subTopic(subTopicId), 'historyFeed'] as const,
  getSubjectTasks: (subTopicId: string) => [...keys.subTopic(subTopicId), 'subjectTasks'] as const,
  getSubjectTasksFiltered: (subTopicId: string, state: 'pending' | 'completed' | null) => [...keys.getSubjectTasks(subTopicId), { state }] as const,

  getPendingItems: (subTopicId: string) => [...keys.subTopic(subTopicId), 'pendingItems'] as const,
  getPendingItemsFiltered: (subTopicId: string, state: 'pending' | 'completed' | null) => [...keys.getPendingItems(subTopicId), { state }] as const,

  getSuggestedProviders: (spaceId: string) => [...keys.lists(), 'suggestedProviders', spaceId] as const,
  getSuggestedContactNames: (spaceId: string) => [...keys.lists(), 'suggestedContactNames', spaceId] as const,
  getSuggestedSubTopics: (search: string) => [...keys.lists(), 'suggestedSubTopics', search] as const,

  // Action specific
  actionDocuments: (actionId: string, subTopicId: string) => [...keys.subTopic(subTopicId), 'actionDocuments', actionId] as const,

  // New Activity Timeline
  activityTimeline: (filters: { subTopicId?: string; providerId?: string }) => [...all, 'activityTimeline', filters] as const,
  activityTimelinePages: (filters: { subTopicId?: string; providerId?: string }, entityType: string) => [...keys.activityTimeline(filters), 'pages', { entityType }] as const,
  activityTimelineCounts: (filters: { subTopicId?: string; providerId?: string }) => [...keys.activityTimeline(filters), 'counts'] as const,
  activityTimelineRecent: (filters: { subTopicId?: string; providerId?: string }, limit: number) => [...keys.activityTimeline(filters), 'recent', limit] as const,

  // Communications
  communications: (filters: { subjectId?: string; providerId?: string; kind?: string }) => [...all, 'communications', filters] as const,
  communicationsPages: (filters: { subjectId?: string; providerId?: string; kind?: string }) => [...keys.communications(filters), 'pages'] as const,

  // Incidents
  subTopicIncidents: (subTopicId: string) => [...keys.subTopic(subTopicId), 'incidents'] as const,
  incidents: (filters: { subjectId?: string; spaceId?: string }) => [...all, 'incidents', filters] as const,

  // Quotes
  subTopicQuotes: (subTopicId: string) => [...keys.subTopic(subTopicId), 'quotes'] as const,
}

